import { loadable } from 'utils';

export const Groups = loadable(() => import('./Groups'), {});
export const Users = loadable(() => import('./Users'), {});
export const UsersPermissions = loadable(() => import('./UsersPermissions'), {});
